import { getDateLabel } from '../../utils/dateTimeFunctions';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { memo } from 'react';
import { EmptyStateCell } from './EmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
const DateTimeCell = ({
  format = 'll',
  i18nTimezoneType,
  value,
  showTime = true
}) => {
  if (value === null || value === undefined || value === '') {
    return /*#__PURE__*/_jsx(EmptyStateCell, {});
  }
  const label = getDateLabel(Number(value), showTime, i18nTimezoneType);
  if (label) {
    return /*#__PURE__*/_jsx("span", {
      children: label
    });
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    format: format,
    type: i18nTimezoneType,
    value: Number(value)
  });
};
export default /*#__PURE__*/memo(DateTimeCell);